import React from "react";
import { react } from "mobx";
import { inject, observer } from "mobx-react";
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {Component} from "react/lib/ReactBaseClasses";
import store from "../../../stores";
import loading from '../../../assets/images/ajax-loader.gif';
import Select from "react-select";
import {Validacao} from "./Validacao";
import _ from "lodash";
import {createSelectOptions} from "../../../utils/formatar";
import FontAwesome from 'react-fontawesome';
import EmpregadoService from "../../../services/EmpregadoService";

@inject("store")
@observer
class FluxoModalForm extends Component {

    constructor(props) {
        super(props);
        this.modalStore = this.props.store.modalStore;
        this.formStore = this.props.store.formStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.observacoesModal = this.observacoesModal.bind(this);
        this.state = {
            listAprovadores: [],
            empregadoService: new EmpregadoService()
        }
    }

    componentWillMount() {
        this.modalStore.setSubmitted(false);
        this.modalStore.setSubmitMensagemErro("");
        this.formStore.setSubmitted(false);
        this.formStore.setSubmitMensagemErro("");
        this.modalStore.setLoading(false);
    }

    observacoesModal() {
        const aprovadoresExtraForm = [];

        const fluxoController = this.props.fluxoController;
        const solicitacao = this.props.fluxoController.solicitacao;
        const razaoAtrasoOptions = createSelectOptions(fluxoController.motivosAtraso, "nome", "nome");
        const razaoDesistenciaAlocacaoETT = createSelectOptions(fluxoController.motivosDesistenciaAlocacaoETT, "nome", "nome");

        if(solicitacao.matriculaAprovadoresExtra) {
            for(let i=0; i<solicitacao.matriculaAprovadoresExtra.length; i++) {
                aprovadoresExtraForm.push(<Row key={i}>
                    <Col xs={12}>
                        {solicitacao.matriculaAprovadoresExtra[i] !== null &&
                        <FormGroup>
                            <div className="multiple-selects">
                                <Select className="multiple-selects-input"
                                        options={this.state.listAprovadores}
                                        value={solicitacao.matriculaAprovadoresExtra[i]}
                                        onChange={(value, option) => {
                                            fluxoController.setMatriculaAprovadoresExtra(value, option, i)
                                        }}
                                        asyncOptions={ (input, callback) => {fluxoController.filtrarAprovadoresExtraDebounce(input,callback);}}
                                        multi={false}
                                        placeholder="Digite a matrícula e selecione..."
                                        searchingText="Pesquisando gestores ativos..."
                                        noResultsText="Nenhum resultado encontrado"
                                />
                                <div className="multiple-selects-buttons">
                                    {(i > fluxoController.posicaoPrimeiroAprovadorExtra || fluxoController.quantidadeAprovadoresExtraMostrados > 1) &&
                                    <a onClick={() => fluxoController.removerAprovadorExtra(i)} title="Remover"><FontAwesome name="minus-circle"/></a>
                                    }
                                    <a onClick={() => fluxoController.adicionarAprovadorExtra(i)}
                                       title="Adicionar"><FontAwesome name="plus-circle"/></a>
                                </div>
                            </div>
                        </FormGroup>
                        }
                    </Col>
                </Row>)
            }
        }

        return (
            <div>
                {fluxoController.exibeAprovadoresExtraDetalhamento &&
                <div>
                    {fluxoController.quantidadeAprovadoresExtraMostrados > 0 && <Label>Aprovadores extra (exceto equipe e técnico operacional)</Label>}
                    {aprovadoresExtraForm}
                    <Validacao id="aprovadoresUnicos" valor={fluxoController.apenasMatriculaAprovadoresExtraValidos} tipo={["isArrayUnique"]} isGroupValidation/>
                </div>
                }
                {fluxoController.isFluxoEtt && fluxoController.isTarefaHTConfirmarContratacao &&
                <div>
                    {fluxoController.confirmarAlocacaoETT.informarDataInicioDiferente && (_.get(this.modalStore, "exibirModal.tipo") !== 'desistir') &&
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>Razão de alteração de início</Label>
                                <Select value={fluxoController.confirmarAlocacaoETT.razaoAtraso}
                                        options={razaoAtrasoOptions}
                                        onChange={(value) => fluxoController.setRazaoAtraso(value)}
                                        noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                        multi={false} />
                                <Validacao id="razaoAtraso" valor={fluxoController.confirmarAlocacaoETT.razaoAtraso}
                                           tipo={["isRequired"]}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    }
                    {(_.get(this.modalStore, "exibirModal.tipo") !== 'desistir') &&
                    <Row>
                        <Col xs={12}>
                            <FormGroup check>
                                <Label check>
                                    <Input type="checkbox" checked={fluxoController.confirmacaoModalEtt} onChange={() => fluxoController.toggleConfirmacaoModalEtt()}/>{' '}
                                    Confirmo que o recurso está apto para iniciar o trabalho na data prevista
                                </Label>
                                <Validacao id="confirmacaoModalEtt" valor={fluxoController.confirmacaoModalEtt} tipo={["isBooleanRequired"]}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    }
                </div>
                }
                {fluxoController.exibeConfirmacaoMTE &&
                <Row>
                    <Col xs={12}>
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" checked={fluxoController.confirmacaoMTE} onChange={() => fluxoController.toggleConfirmacaoModalMTE()}/>{' '}
                                Confirmo aprovação do MTE
                            </Label>
                            <Validacao id="confirmacaoModalMTE" valor={fluxoController.confirmacaoMTE} tipo={["isBooleanRequired"]}/>
                        </FormGroup>
                    </Col>
                </Row>
                }
                {_.get(this.modalStore, "exibirModal.tipo") === 'desistir' &&
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <Label>Razão de desistência <sup>*</sup></Label>
                            <Select value={fluxoController.confirmarAlocacaoETT.razaoDesistencia}
                                options={razaoDesistenciaAlocacaoETT}
                                onChange={(value) => fluxoController.setRazaoDesistenciaAlocacaoETT(value)}
                                noResultsText="Nenhum resultado encontrado" placeholder="Selecione..."
                                multi={false} />
                            <Validacao id="razaoDesistencia" valor={fluxoController.confirmarAlocacaoETT.razaoDesistencia}
                                tipo={["isRequired"]}/>
                        </FormGroup>
                    </Col>
                </Row>
                }
                <FormGroup>
                    {(_.get(this.modalStore, "exibirModal.tipo") === 'desistir' || _.get(this.modalStore, "exibirModal.tipo") === 'rejeitar'
                        || _.get(this.modalStore, "exibirModal.tipo") === 'demandarAjustes' || _.get(this.modalStore, "exibirModal.tipo") === 'cancelar') ? (
                        <Label>Observações <sup>*</sup></Label>
                    ):(
                        <Label>Observações</Label>
                    )}
                    <Input type="textarea" maxLength={1024} value={fluxoController.observacoes} onChange={(event) => fluxoController.setObservacoes(event.target.value)}  />
                    {(_.get(this.modalStore, "exibirModal.tipo") === 'desistir' || _.get(this.modalStore, "exibirModal.tipo") === 'rejeitar' || _.get(this.modalStore, "exibirModal.tipo") === 'demandarAjustes' || _.get(this.modalStore, "exibirModal.tipo") === 'cancelar') && <Validacao id="observacoes" valor={fluxoController.observacoes} tipo={["isRequired"]} />}
                </FormGroup>
            </div>
        )
    }

    render() {
        return (

            <Modal backdrop={'static'} keyboard={!this.modalStore.loading} isOpen={true} toggle={() => {
                this.modalStore.toggleModal();
                this.validacaoStore.desabilitarValidacao = false;
            }}>
                <ModalHeader>{this.props.cabecalho}</ModalHeader>
                <ModalBody>
                    <Form>
                    {this.observacoesModal()}
                    </Form>
                </ModalBody>
                {this.props.botoes &&
                    <ModalFooter>
                        <p>{ this.modalStore.submitMensagemErro }</p>
                        {this.modalStore.loading ? <img src={loading} alt="loading" className="loading"/> : ""}
                        { this.props.botoes }
                    </ModalFooter>
                }
            </Modal> );
    }
};

export {FluxoModalForm}